<template>
  <div class="super-spam-blaster main">
    <button class="delete is-large" @click="close" />
    <h1 class="subtitle">
      <span>Spam Blaster</span>
    </h1>

    <div class="field">
      <textarea
        class="textarea is-dark"
        v-model="message"
        placeholder="Put spam here 🥓"
        rows="4"
      ></textarea>
    </div>

    <div class="buttons">
      <span
        v-for="t in targetGroups"
        :key="t"
        class="button is-rounded is-link"
        :class="{ 'is-outlined': t !== target }"
        @click="setTargetGroup(t)"
      >
        {{ t }}
      </span>
    </div>
    <div>
      <span
        v-if="sent"
        class="button is-success is-fullwidth is-medium"
        @click="close"
      >
        Success!
      </span>
      <span
        v-else-if="target"
        class="button is-rounded is-warning is-fullwidth is-medium"
        @click="send"
      >
        Send Broadcast
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuperSpamBlaster",
  data() {
    return {
      message: null,
      sent: false,
      target: null,
      targetGroups: ["Superusers", "Commerce Agents"],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    setTargetGroup(t) {
      this.target = t;
      this.sent = false; // reset to send again
    },
    send() {
      if (!this.message || this.message.length < 5) {
        return this.errorToast("Enter a valid broadcast message");
      }
      var data = {
        target_group: this.target,
        // target: "all", // could be country, city, etc
        message: this.message,
      };
      var loader = this.loadingDots("pink");
      this.$store
        .dispatch("sendBroadcastMessage", data)
        .then(() => (this.sent = true))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: calc(100vh - 58px);
  z-index: 2;
  /* random z-index higher than modal */
  /* backdrop-filter: blur(3px); */
  overflow: hidden;
  padding: 12px;
  text-align: left;
  background-color: rgba(17, 34, 51, 1);
}
.subtitle {
  color: white;
  opacity: 0.7;
  font-weight: 450;
  margin-left: 10px;
  margin-top: 6px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
.textarea {
  background-color: rgb(210, 212, 208);
  color: slateblue;
}
</style>